import { getController } from '../service'

const url = 'addresses'

export const addressService = {
	...getController<Api.Address, Api.AddressPostInput, Api.AddressPostInput>(
		url
	),
}

export default addressService
